import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

import { ClientRouter } from "./ClientRouter";
import { SiteRouter } from "./SiteRouter";
import { SettingsRouter } from "./SettingsRouter";
import Dashboard from "../component/features/home/Dashboard";
import { ProjectRouter } from "./ProjectRouter";
import { InvoiceRouter } from "./InvoiceRouter";
import { PlanRouter } from "./PlanRouter";
import LandingPage from "../component/features/home/LandingPage";
import UserAgreement from "../component/features/home/UserAgreement";
import NotFound from "../component/features/home/NotFound";
import { isAuthorized } from "../shared/settings/auth";
import AdminRoute from "../component/common/AdminRoute";
import UserProfile from "../component/features/user/UserProfile";
import AdminLayout from "../component/features/admin/AdminLayout";
import AdminDashboard from "../component/features/admin/Dashboard";
import UserList from "../component/features/admin/UserList";
import AdminPlanList from "../component/features/admin/AdminPlanList";
import PlanAssign from "../component/features/plans/PlanAssign";

const AppRouter = ({}) => {

    return (
        <Switch>
            <Route exact path="/" component={LandingPage} />
            <Route exact path="/user-agreement" component={UserAgreement} />
            <Route
                exact
                path="/home"
                render={(routeProps) =>
                    isAuthorized() ? (
                        <Dashboard {...routeProps} />
                    ) : (
                        <Redirect to="/" />
                    )
                }
            />

            <Route path="/clients">
                {isAuthorized() ? <ClientRouter /> : <Redirect to="/" />}
            </Route>
            <Route path="/sites">
                {isAuthorized() ? <SiteRouter /> : <Redirect to="/" />}
            </Route>
            <Route path="/projects">
                {isAuthorized() ? <ProjectRouter /> : <Redirect to="/" />}
            </Route>
            {/* <Route path="/invoices" component={InvoiceRouter} /> */}
            <Route path="/plans">
                {isAuthorized() ? <PlanRouter /> : <Redirect to="/" />}
            </Route>
            <Route exact path="/profile">
                {isAuthorized() ? <UserProfile /> : <Redirect to="/" />}
            </Route>
            <Route path="/settings">
                {isAuthorized() ? <SettingsRouter /> : <Redirect to="/" />}
            </Route>
            <Route path="/admin">
                <AdminRoute>
                    <AdminLayout>
                        <Switch>
                            <Route exact path="/admin" render={() => <Redirect to="/admin/dashboard" />} />
                            <Route exact path="/admin/dashboard" component={AdminDashboard} />
                            <Route exact path="/admin/users" component={UserList} />
                            <Route exact path="/admin/plans" component={AdminPlanList} />
                            <Route exact path="/admin/plans/assign" component={PlanAssign} />
                            <Redirect to="/admin/dashboard" />
                        </Switch>
                    </AdminLayout>
                </AdminRoute>
            </Route>
            <Route exact path="/not-found" component={NotFound} />
            <Redirect to="/not-found" />
        </Switch>
    );
};

export default AppRouter;
